import React, {FunctionComponent, useContext} from "react";
import {ChallengeRegistrationData, RegistrationStatus} from "/src/domain/challenges/ChallengeRegistrationData";
import {ChallengeUser} from "/src/domain/challenges/ChallengeUser";
import {Button} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {useTranslation} from "react-i18next";
import {
    ChallengeRegistrationContext,
    ChallengeRegistrationContextProps
} from "/src/contexts/ChallengeRegistrationContext";

export type RegistrationSubmitButtonProps = {
    challengeData: ChallengeRegistrationData,
    currentUser: ChallengeUser,
    disabled?: boolean,
}

export const RegistrationSubmitButton: FunctionComponent<RegistrationSubmitButtonProps> = ({
                                                                                               challengeData,
                                                                                               currentUser,
                                                                                               disabled,
                                                                                           }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const {currency} = useContext(ChallengeRegistrationContext) as ChallengeRegistrationContextProps;
    const paymentUrl = challengeData?.payment?.paymentUrl?.[currency] ?? "";

    const handleSubmit = () => {
        window.ym(42095429, 'reachGoal', 'REG_EVENT');
        window.fbq('track', 'AddToCart');
        window._tmr.push({ type: 'reachGoal', id: 3332099, goal: 'REG_EVENT'});
        window._tmr.push({ type: 'reachGoal', id: 3538927, goal: 'REG_EVENT'});
        window.VK.Goal('complete_registration')
        return false;
    }

    if ((!challengeData.isPaid || challengeData.payment?.status == RegistrationStatus.PAID) && currentUser.challengeRegistration.isRegistered) return null;

    if (challengeData.isPaid) {
        if (challengeData.payment?.status == null) {
            return (
                <Button className={classes.submitButton} type={"submit"} variant={"contained"} name="regme"
                        color={"secondary"} value={t('goToPayLabel')}
                        onClick={handleSubmit} disabled={disabled}>{t('goToPayLabel')}</Button>
            )
        }

        if (challengeData.payment?.status == RegistrationStatus.NEW) {
            return (
                <Button className={classes.submitButton} href={paymentUrl} variant={"contained"}
                        color={"secondary"} value={t('goToPayLabel')}>{t('goToPayLabel')}</Button>
            )
        }

        return null;
    } else {
        if (!currentUser.challengeRegistration.isRegistered) {
            return (
                <Button className={classes.submitButton} type={"submit"} variant={"contained"} name="regme"
                        color={"secondary"} value={t('registerLabel')}
                        onClick={handleSubmit} disabled={disabled}>{t('registerLabel')}</Button>
            )
        }

        if (challengeData.locations.length > 0) {
            return (
                <Button className={classes.submitButton} type={"submit"} variant={"contained"} name="regme"
                        color={"secondary"} value={t('saveLabel')}
                        onClick={handleSubmit} disabled={disabled}>{t('saveLabel')}</Button>
            )
        }

        return null;
    }
}

const useStyles = makeStyles({
    submitButton: {
        width: "100%",
        maxWidth: "30rem",
        margin: "1rem auto",
        display: "block",
        textAlign: "center"
    },
});